import { formatDistanceToNow } from 'date-fns';

// Function to format Firestore timestamp to "time ago" format
export const formatDate = (timestamp) => {
  const date = timestamp.toDate(); // Convert Firestore Timestamp to JavaScript Date object
  return formatDistanceToNow(date, { addSuffix: true }); // Format date to "time ago" format
};

export const userColumns = [
  { 
    field: "id",
    headerName: "ID",
    width: 200 
  },
  { 
    field: "title",
    headerName: "Title",
    width: 200 
  },
  {
    field: "message",
    headerName: "Message",
    width: 400,
  },
  {
    field: "timestamp",
    headerName: "Timestamp",
    width: 120,
    valueGetter: (params) => formatDate(params.value), // Use valueGetter to format createdAt field
  },
];
